import React from 'react'
import styles from './styles.module.scss'
import ShoppingCart from '@/src/interfaces/system/shopping-cart'

interface Props {
    cartItem: ShoppingCart.CartItem,
    titleFontSize: 'font-md' | 'font-xmd'
    itemsFontSize: 'font-sm' | 'font-md'
    isDrawer?: boolean
}

export default function ItemsTree(props: Props) {
    const getItemQuantity = (item: ShoppingCart.CartItem, subItem: ShoppingCart.CartItem): string => {
        const productsSizesLength = item.subItems?.filter(c => c.type === 'productBySize' || c.type === 'productBySizeWithWizard').length

        if (productsSizesLength && productsSizesLength > 1 && (subItem.type === 'productBySize' || subItem.type === 'productBySizeWithWizard')) {
            if (subItem.quantity && subItem.quantity > 0 && subItem.quantity < 1) {
                return `1/${productsSizesLength}`
            } else {
                return `${subItem.quantity}x`
            }
        } else {
            if (subItem.type === 'productBySize' || subItem.type === 'productBySizeWithWizard' || subItem.isGroup || !Number.isInteger(item.quantity))
                return `1x`
            else
                return `${subItem.quantity ?? 1}x`
        }
    }

    const renderObservation = (item: ShoppingCart.CartItem) => {        
        const observations = item.subItems?.filter(c => c.type === 'observation') ?? undefined
        if (item.observation) {
            observations?.push({ observation: item.observation } as ShoppingCart.CartItem);
        }
        if (observations && observations.length > 0) {
            const observationTitles = observations.map((item) => item.observation || item.name).join(', ')
            return (
                <div>
                    <i className={`${styles.itemObservation} ${props.itemsFontSize}`}>{observationTitles}</i>
                </div>
            )
        }
    }
    const renderComplements = (item: ShoppingCart.CartItem) => {
        const complements = item.subItems?.filter(c => c.type === 'complement') ?? undefined
        if (complements && complements.length > 0) {
            return complements.map((complement) => {
                return (
                    <div id={complement.id} className={styles.complements} key={complement.id}>
                        <span className={`${styles.itemComplement} ${props.itemsFontSize}`}>
                            <b>{complement.type !== 'observation' && (`${getItemQuantity(item, complement)}`)}</b> {complement.name}
                        </span>
                    </div>
                )
            })
        }
    }

    const renderOtherItems = (item: ShoppingCart.CartItem) => {
        const otherItems = item.subItems?.filter(c => c.type !== 'complement' && c.type !== 'observation') ?? undefined
        if (otherItems && otherItems.length > 0) {
            return otherItems.map((otherItem, index) => {
                return (
                    <div id={otherItem.id} className={styles.complements} key={index}>
                        <span className={styles.itemComplement}><b>{getItemQuantity(item, otherItem)}</b> {otherItem.name}</span>
                        <div className={styles.ident}>
                            {renderObservation(otherItem)}
                            {renderComplements(otherItem)}
                        </div>
                    </div>
                )
            })
        }

        return <></>
    }

    const renderAllItems = (item: ShoppingCart.CartItem) => {
        return (
            <div>
                {renderObservation(item)}
                {
                    item.type === 'productBySize' || item.type === 'productBySizeWithWizard' ?
                        <>
                            {renderOtherItems(item)}
                            {renderComplements(item)}
                        </> :
                        <>
                            {renderComplements(item)}
                            {renderOtherItems(item)}
                        </>
                }
            </div>
        )
    }

    return (
        <div className={styles.descriptionArea}>
            <h5 className={`${styles.productName} ${props.titleFontSize}`}>
                {(props.cartItem.quantity > 1 && !props.isDrawer) && <b>{props.cartItem.quantity}x</b>} {props.cartItem.personalizedName ?? props.cartItem.name}
            </h5>
            <i className={`${styles.description} font-sm`}>{props.cartItem.observation}</i>
            {renderAllItems(props.cartItem)}
        </div>
    )
}
